import image from '../assets/images/robot-error.svg'
export const ROBOT_ERROR_IMG = image
